import { styled } from "styled-components";
import { Swiper } from "swiper/react";

export const WrappedSwiper = styled(Swiper)`
  width: 100%;
  height: 100%;

  .swiper-button-prev,
  .swiper-button-next {
    color: #a43424 !important;
    top: 25% !important;
    &::after {
      font-size: 30px;
      font-weight: 900;
    }
  }

  .swiper-pagination {
    background-color: #fcfcfc;
  }

  .swiper-pagination-bullet-active {
    opacity: 1;
    background: #a43424;
  }

  .swiper-slide {
    //min-height: 355px;
    padding-bottom: 35px;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: start;
    -ms-flex-align: start;
    -webkit-align-items: start;
    align-items: start;

    a {
      display: flex;
      flex-direction: column;
      color: #000;
      text-decoration: none;
      > div {
        &:first-child {
          height: 200px;
        }
        &:last-child {
          min-height: 160px;
        }
        position: relative;
        width: 200px;
        align-self: center;
        img {
          display: block;
          width: 200px;
          height: 200px;
          object-fit: cover;
        }
      }
      b {
        font-size: 16px;
        word-wrap: break-word;
      }
      p {
        font-size: 13px;
        max-height: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        /*white-space: nowrap;*/
      }
    }
  }
`;
